export const DateOrderIdentifiers = {
  DayMonthYear: "DayMonthYear",
  MonthDayYear: "MonthDayYear",
  YearMonthDay: "YearMonthDay"
};

export const DateOrderNames = {
  DayMonthYear: "Day/Month/Year",
  MonthDayYear: "Month/Day/Year",
  YearMonthDay: "Year/Month/Day"
};

export const csvImportDateOrderNames = {
  DayMonthYear: "DD/MM/YYYY",
  MonthDayYear: "MM/DD/YYYY",
  YearMonthDay: "YYYY/MM/DD"
};

const createCsvImportDateOrderOption = id => ({
  label: csvImportDateOrderNames[id],
  value: id
});

export const csvImportDateOrderOptions = Object.keys(DateOrderIdentifiers).map(k => createCsvImportDateOrderOption(k));

const createDateOrder = id => {
  return {
    identifier: id,
    name: DateOrderNames[id]
  };
};

export default [
  createDateOrder(DateOrderIdentifiers.DayMonthYear),
  createDateOrder(DateOrderIdentifiers.MonthDayYear),
  createDateOrder(DateOrderIdentifiers.YearMonthDay)
];
